import { Component, OnInit,Output,EventEmitter,Input } from '@angular/core';
import { Sortingfield } from '../../../enums/sortingfield';

@Component({
  selector: 'app-sorting',
  templateUrl: './sorting.component.html',
  styleUrls: ['./sorting.component.scss']
})
export class SortingComponent implements OnInit {
  @Output() sortingType:EventEmitter<object>= new EventEmitter(); 
  @Input() isActive: boolean =false;
  @Input() sortType :String; 
  @Input() colName: String=Sortingfield.probability;
  @Output() popUpMouseOut:EventEmitter<object>= new EventEmitter(); 
  @Input() data: any[];
  constructor() { }

  ngOnInit(): void {
  }

  sendValues(val:any){
    this.sortingType.emit({value : val,col:this.colName});    
 } 

 closePopUp(){
  this.popUpMouseOut.emit(this.colName);
 }

}
